import type { Environment } from "../../types";

export { WALLET_API, CHAIN_IDS } from "../../lib/constants";

export const REWARD_API: Record<Environment, string> = {
  dev: "https://stg-cross-game-reward-api.crosstoken.io/api",
  stage: "https://stg-cross-game-reward-api.crosstoken.io/api",
  production: "https://cross-game-reward-api.crosstoken.io/api",
};

export const REWARDS_WEB: Record<Environment, string> = {
  dev: "https://stg.onechain.nexus",
  stage: "https://stg.onechain.nexus",
  production: "https://onechain.nexus",
};

/**
 * CROSS Points(My-Point) 웹 URL. Points 섹션에서 내장 Withdraw가 불가능한
 * 환경(sendTransaction 미주입)의 아웃링크 폴백 대상.
 * app-launcher-v2.json `points` 항목과 동일한 목적지.
 */
export const POINTS_WEB: Record<Environment, string> = {
  dev: "https://stg.onechain.nexus/points",
  stage: "https://stg.onechain.nexus/points",
  production: "https://www.onechain.nexus/points",
};

export const FORGE_API: Record<Environment, string> = {
  dev: "https://stg-bonding-curve-api.crosstoken.io/api",
  stage: "https://stg-bonding-curve-api.crosstoken.io/api",
  production: "https://bonding-curve-api.crosstoken.io/api",
};

export const DEX_WEB: Record<Environment, string> = {
  dev: "https://stg.onechain.nexus",
  stage: "https://stg.onechain.nexus",
  production: "https://onechain.nexus",
};

/**
 * POSA(staking/governance) 백엔드 REST API. `GET /stake/:address`,
 * `GET /network/stats` 등을 제공한다. posa 레포의 env.API.GOVERNANCE 기준.
 * dev/stage는 staging 백엔드를 공유한다(다른 섹션 컨벤션과 동일).
 */
export const POSA_API: Record<Environment, string> = {
  dev: "https://stg-posa-api.crosstoken.io/api/v1",
  stage: "https://stg-posa-api.crosstoken.io/api/v1",
  production: "https://posa-api.crosstoken.io/api/v1",
};

/** Staking 웹 도메인 루트. 미스테이킹 상태의 "Stake Now" 아웃링크 대상. */
export const STAKING_WEB_HOME: Record<Environment, string> = {
  dev: "https://dev-stake.ogfcorp.com",
  stage: "https://stg-stake.ogfcorp.com",
  production: "https://stake.ogfcorp.com",
};

/** Staking 대시보드(포트폴리오) 웹 URL. 스테이킹 보유 시 "Manage" 아웃링크 대상. */
export const STAKING_WEB: Record<Environment, string> = {
  dev: `${STAKING_WEB_HOME.dev}/portfolio`,
  stage: `${STAKING_WEB_HOME.stage}/portfolio`,
  production: `${STAKING_WEB_HOME.production}/portfolio`,
};

/**
 * game-swap 백엔드 REST API. `GET /addresses/:address/portfolio`로 사용자가
 * 참여한 풀 목록을 제공한다. cross-game-swap 레포의 env.API.GAME_SWAP 기준.
 * dev/stage는 staging 백엔드를 공유한다(다른 섹션 컨벤션과 동일).
 * NOTE: 도메인이 crosstoken.io가 아니라 cross.nexus 임에 유의.
 */
export const GAME_SWAP_API: Record<Environment, string> = {
  dev: "https://stg-game-swap-api.cross.nexus/v1",
  stage: "https://stg-game-swap-api.cross.nexus/v1",
  production: "https://game-swap-api.cross.nexus/v1",
};

/**
 * game-swap 웹 URL. "Manage" 아웃링크 대상. 유동성 관리는
 * `/tokens/:tokenAddress?trade=deposit` 경로를 사용한다.
 */
export const GAME_SWAP_WEB: Record<Environment, string> = {
  dev: "https://stg.onechain.nexus",
  stage: "https://stg.onechain.nexus",
  production: "https://onechain.nexus",
};

export const APP_LAUNCHER_ICONS_BASE: Record<Environment, string> = {
  dev: "https://stg-contents.crosstoken.io/frontend/common/app-launcher/icons",
  stage: "https://stg-contents.crosstoken.io/frontend/common/app-launcher/icons",
  production: "https://contents.crosstoken.io/frontend/common/app-launcher/icons",
};
